import { clsx } from "clsx";
import type { ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Join class names; a later Tailwind class overrides an earlier one of its kind. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
